import { createAsyncThunk } from "@src/store";
import { setProductPickerSelectingAllProducts } from "@src/store/slices/productPicker";
import { toggleSelectAll } from "@src/store/slices/productPicker/thunks/toggleSelectAll";
import { ProductPickerProductDataSource } from "@src/store/slices/productPicker/util/ProductPickerProductDataSource";

export const loadAndSelectAll = createAsyncThunk<
  void,
  ProductPickerProductDataSource
>("productPicker/loadAndSelectAll", async (dataSource, { dispatch }) => {
  dispatch(setProductPickerSelectingAllProducts(true));
  await dataSource.loadAll();
  dispatch(setProductPickerSelectingAllProducts(false));
  await dispatch(toggleSelectAll());
});
